import { isPositiveNumber, reduce } from "et3-type-guards";

import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import { SURFACE_BORDER } from "../../../../core/et3-theme/surface-constants";
import { countPendingItems } from "../../../../stores/approval-reject-store/approval-item-counts";
import { TUserEntry } from "../../../../Types";
import DescriptionLane from "./lanes/DescriptionLane";
import PicturesLane from "./lanes/PicturesLane";
import UserRowHeader from "./UserRowHeader";
import {
  LANE_COLUMN_GAP,
  LANE_PADDING_LEFT,
  LANE_PADDING_Y,
  LANES_PADDING_X,
  ROW_ACCENT_WIDTH
} from "./lanes/lane-constants";

const UserRow = withLiteObserverAndTheme<{
  userEntry: TUserEntry;
  isLastRow: boolean;
}>((props) => {
  const { userEntry, isLastRow, theme } = props;
  const { colors, unitX, unitY } = theme;
  const userId = reduce(() => userEntry.user_id, -1);
  const userUUID = reduce(() => userEntry.userUUID, "");
  const hasPendingWork = isPositiveNumber(countPendingItems(userEntry));
  const laneStyle = {
    boxSizing: "border-box" as const,
    width: "100%",
    minWidth: 0,
    paddingTop: LANE_PADDING_Y * unitY,
    paddingBottom: LANE_PADDING_Y * unitY
  };

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="row"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        borderBottom: isLastRow ? "none" : SURFACE_BORDER
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={ROW_ACCENT_WIDTH}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="flex-start"
        color={hasPendingWork ? colors.all.darkOrange : colors.all.shadeOfGray}
        style={{ flexShrink: 0 }}
        onClick={() => {}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ flex: 1, minWidth: 0, width: "auto" }}
        onClick={() => {}}
      >
        <UserRowHeader userEntry={userEntry} />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={0}
          height={0}
          fDirection="row"
          alignItems="stretch"
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={{
            boxSizing: "border-box",
            width: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns:
              "minmax(0, 0.94fr) minmax(0, 1fr) minmax(0, 1fr)",
            columnGap: LANE_COLUMN_GAP * unitX,
            alignItems: "stretch",
            paddingLeft: LANES_PADDING_X * unitX,
            paddingRight: LANES_PADDING_X * unitX
          }}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            withShadow={false}
            width={0}
            height={0}
            fDirection="column"
            alignItems="stretch"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={laneStyle}
            onClick={() => {}}
          >
            <PicturesLane userEntry={userEntry} />
          </ET3Div>
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            withShadow={false}
            width={0}
            height={0}
            fDirection="column"
            alignItems="stretch"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{
              ...laneStyle,
              borderLeft: SURFACE_BORDER,
              paddingLeft: LANE_PADDING_LEFT * unitX
            }}
            onClick={() => {}}
          >
            <DescriptionLane
              titleKey={"DESCRIPTION_ABOUT_ME"}
              isSelfDescription={true}
              userId={userId}
              userUUID={userUUID}
              descriptionId={reduce(() => userEntry.descriptionID, -1)}
              descriptionStatus={reduce(
                () => `${userEntry.descriptionStatus}`,
                ""
              )}
              description={reduce(() => userEntry.description, "")}
              descriptionLanguage={reduce(
                () => userEntry.descriptionLanguage,
                ""
              )}
              isGeneratedByAi={reduce(
                () => userEntry.descriptionIsGeneratedByAi,
                0
              )}
            />
          </ET3Div>
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            withShadow={false}
            width={0}
            height={0}
            fDirection="column"
            alignItems="stretch"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{
              ...laneStyle,
              borderLeft: SURFACE_BORDER,
              paddingLeft: LANE_PADDING_LEFT * unitX
            }}
            onClick={() => {}}
          >
            <DescriptionLane
              titleKey={"DESCRIPTION_ABOUT_MY_PARTNER"}
              isSelfDescription={false}
              userId={userId}
              userUUID={userUUID}
              descriptionId={reduce(() => userEntry.peerDescriptionID, -1)}
              descriptionStatus={reduce(
                () => `${userEntry.peerDescriptionStatus}`,
                ""
              )}
              description={reduce(() => userEntry.peerDescription, "")}
              descriptionLanguage={reduce(
                () => userEntry.peerDescriptionLanguage,
                ""
              )}
              isGeneratedByAi={0}
            />
          </ET3Div>
        </ET3Div>
      </ET3Div>
    </ET3Div>
  );
});
export default UserRow;
